// Função para observar alterações no DOM
const observeElementorMessage = () => {
    const observer = new MutationObserver((mutationsList, observer) => {
        const formVerify = document.querySelector('.form-verification');
        const firstForm = document.querySelector('.first-form');
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const successMessage = document.querySelector('.elementor-message-success');
          if (successMessage) {
            formVerify.classList.remove('hidden');
            firstForm.classList.add('hidden');
            observer.disconnect();
          }
        }
      }
    });
  
    // Configura o observer para monitorar adições e remoções de elementos no DOM
    observer.observe(document.body, {
      childList: true,
      subtree: true, // Para monitorar alterações em todo o DOM
    });
}

export {observeElementorMessage}